module.exports = __webpack_public_path__ + "static/contribution_img4_on@2x-714465e012397bcdb84a875388917bee.jpg";